export var ProductAttributeKey;
(function (ProductAttributeKey) {
    ProductAttributeKey["MetaProductType"] = "Meta_Producttype";
})(ProductAttributeKey || (ProductAttributeKey = {}));
